/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import { LOAD_ATTENDENCE,LOAD_MONTHLY_RECORD,LOAD_CHECKINOUT} from "./constants";

import {
  loadMonthlyRecord,
  loadMonthlyRecordSuccess,
  loadMonthlyRecordError,
  loadAttendence,
  loadAttendenceSuccess,
  loadAttendenceError,
  loadCheckinOut,
  loadCheckinOutSuccess,
  loadCheckinOutError
} from "./actions";

import { loadMonthlyRecordDetails, loadAttendenceAPI, loadCheckinOutAPI } from "./remotes";

function* loadMonthlyRecordSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_MONTHLY_RECORD),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadMonthlyRecord(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadMonthlyRecordDetails, searchFilter);
        if (result) {
          yield put(loadMonthlyRecordSuccess(result));
        }
      } catch (error) {
        yield put(
          loadMonthlyRecordError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadAttendenceSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_ATTENDENCE),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadAttendence(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadAttendenceAPI, searchFilter);
        if (result) {
          yield put(loadAttendenceSuccess(result.data));
        }
      } catch (error) {
        yield put(
          loadAttendenceError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadCheckinOutSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_CHECKINOUT),
    });

    const { explicitLoad } = load;
    const { searchFilter } = explicitLoad || {};
    yield put(loadCheckinOut(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadCheckinOutAPI, searchFilter);
        console.log(result,"results")
        if (result) {
          yield put(loadCheckinOutSuccess(result.result));
        }
      } catch (error) {
        yield put(
          loadCheckinOutError(
            (error && error.response && error.response.message) ||
            "Fetch Records Failed"
          )
        );
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([loadMonthlyRecordSaga(), loadAttendenceSaga(),loadCheckinOutSaga()]);
}
